import React, { Component } from "react";
import { Container, Form, Row, Col, Button, Alert } from "react-bootstrap";
import "./UserDetails.css";
import "../../styles/Common.css";
import axios from "../../axios-http";
import axiosStreet from "axios";
import Loading from "../UI/Spinner/Spinner";
import UserContext from "../../context/user-context";
import SampleAlert from "../../Alert.json";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Image from "mui-image";
import Grid from "@mui/material/Grid";
import { AddressInput } from "./AddressInput";

class UserDetails extends Component {
  static contextType = UserContext;

  state = {
    accountNumber: "",
    checkNoBillingNumber: false,
    houseNumber: "",
    streetName: "",
    city: "",
    province: "",
    unitNumber: "",
    streetAddress: "",
    value: "",
    setProvinceValues: [],
    valid: true,
    errorMessage: "",
    errorHeader: "",
    alertHeader: "",
    alertMessage: "",
    loading: false,
    // values : '',
    valuesArray: [],
  };

  componentDidMount() {
    document.addEventListener("keydown", this.onKeyPress, false);

    caches.keys().then((names) => {
      names.forEach((name) => {
        console.warn("name:");
        console.warn("name:");
        caches.delete(name);
      });
    });

    if (this.props.location.state != null && this.props.location.state.isEdit) {
      if (
        sessionStorage.getItem("AccountNumber") === "" ||
        sessionStorage.getItem("AccountNumber") == null
      ) {
        this.setState({ checkNoBillingNumber: true });
      } else {
        this.setState({
          accountNumber: sessionStorage.getItem("AccountNumber"),
        });
        document.querySelector('input[id = "accountNumber"]').value =
          sessionStorage.getItem("AccountNumber");
      }
      var ud = JSON.parse(sessionStorage.getItem("ud"));
      if (ud !== null || ud !== "") {
        this.setState({ houseNumber: ud.houseNumber });
        this.setState({ streetName: ud.streetName });
        this.setState({ city: ud.city });
        this.setState({ province: ud.province });
        this.setState({ streetAddress: ud.streetAddress });
        this.setState({ value: ud.houseNumber + " " + ud.streetName });
        // document.querySelector('input[id = "formHouseNumber"]').value = ud.houseNumber;
        // document.querySelector('input[id = "formStreetName"]').value = ud.streetName;
        // document.querySelector('input[id = "formCity"]').value = ud.city;
        // document.querySelector('input[id = "formProvince"]').value = ud.province;
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPress, false);
  }

  checkValidity() {
    var message = "";
    if (
      this.state.accountNumber.length === 0 &&
      !this.state.checkNoBillingNumber
    ) {
      if (message.length === 0) message += "<ul>";
      message +=
        "<li>EPCOR Account Number is a required field. If not available, please check the ‘I do not have an EPCOR account number’ box.</li>";
    }

    if (
      this.state.houseNumber.length === 0 ||
      this.state.streetName.length === 0
    ) {
      if (message.length === 0) message += "<ul>";
      message += "<li>Street address is a required field.</li>";
    }

    if (this.state.city.length === 0) {
      if (message.length === 0) message += "<ul>";
      message += "<li>City is a required field.</li>";
    }

    if (this.state.province.length === 0) {
      if (message.length === 0) message += "<ul>";
      message += "<li>Province is a required field.</li>";
    }

    if (message.length !== 0) {
      message += "<ul>";
      // message = message.slice(5);
    }

    this.setState({ errorMessage: message });
    this.setState({ errorHeader: "Required Field" });
    if (message.length === 0) {
      this.setState({ valid: true });
      return true;
    } else {
      this.setState({ valid: false });
      return false;
    }
  }

  authenticateUserAPI = (eventType) => {
    this.setState({ loading: true });

    var billingAccountNumber = "";

    if (this.state.checkNoBillingNumber) {
      billingAccountNumber = "";
    } else {
      billingAccountNumber = this.state.accountNumber;
    }
    const payLoad = {
      ServiceProviderName:
        "" + process.env.REACT_APP_SERVICE_PROVIDER_NAME + "",
      billingAccountNumber: "" + billingAccountNumber + "",
      HouseNumber: "" + this.state.houseNumber + "",
      StreetName: "" + this.state.streetName + "",
      City: "" + this.state.city + "",
      Province: "" + this.state.province + "",
      UnitNumber: "" + this.state.unitNumber ? this.state.unitNumber : "" + "",
    };

    axios("")
      .post("/validateLocationAddressWebImport", JSON.stringify(payLoad))
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.StatusCode === "200") {
          const requestType =
            response.data.customerLocationInformation[0]
              .lstRequestTypeCategories;
          var requestTypeToShow = [];
          const select = {
            workflowType: "--Select--",
            reqestTypeCategory: "",
            requestTypeCode: "",
            requestTypeName: "--Select--",
          };
          if (this.state.accountNumber !== "") {
            requestTypeToShow = requestType;
            requestTypeToShow.unshift(select);
          } else {
            requestTypeToShow.push(select);
            requestType.forEach((item) => {
              if (item.reqestTypeCategory !== "Billable") {
                requestTypeToShow.push(item);
              }
            });
          }

          const { setUserDetails } = this.context;
          var ud = {
            accountNumber: this.state.accountNumber,
            houseNumber: this.state.houseNumber,
            streetName: this.state.streetName,
            city: this.state.city,
            province: this.state.province,
            streetAddress: this.state.streetAddress,
            fullAddress:
              response.data.customerLocationInformation[0].locationAddress,
            requestType: requestTypeToShow,
            locationId:
              response.data.customerLocationInformation[0].customerLocationId,
            isAuthenticated: true,
            unitNumber: this.state.unitNumber
          };

          sessionStorage.setItem("Address", ud.fullAddress);
          sessionStorage.setItem("Loc", ud.locationId);
          sessionStorage.setItem("AccountNumber", ud.accountNumber);
          sessionStorage.setItem("UnitNumber", ud.unitNumber);
          sessionStorage.setItem("RequestType", JSON.stringify(ud.requestType));
          sessionStorage.setItem(
            "Products",
            JSON.stringify(
              response.data.customerLocationInformation[0].lstAssets
            )
          );
          sessionStorage.setItem("SwapMessage", response.data.Message);
          sessionStorage.setItem(
            "NewAssetSelectionMessage",
            response.data.receivingCartInfo
          );
          var userAddress = {
            houseNumber: ud.houseNumber,
            streetName: ud.streetName,
            city: ud.city,
            province: ud.province,
            streetAddress: ud.streetAddress,
          };
          sessionStorage.setItem("ud", JSON.stringify(userAddress));

          setUserDetails(ud);
          var segment = "";
          if (
            "" + process.env.REACT_APP_SEGMENT_1_SEGMENT + "" ===
            response.data.customerLocationInformation[0].segmentId
          ) {
            segment = "SEGMENT_1";
          } else if (
            "" + process.env.REACT_APP_SEGMENT_2_SEGMENT + "" ===
            response.data.customerLocationInformation[0].segmentId
          ) {
            segment = "SEGMENT_2";
          } else if (
            "" + process.env.REACT_APP_SEGMENT_3_SEGMENT + "" ===
            response.data.customerLocationInformation[0].segmentId
          ) {
            segment = "SEGMENT_3";
          } else if (
            "" + process.env.REACT_APP_SEGMENT_4_SEGMENT + "" ===
            response.data.customerLocationInformation[0].segmentId
          ) {
            segment = "SEGMENT_4";
          }

          sessionStorage.setItem("Seg", segment);
          if (eventType === "create-request") {
            this.props.history.push({
              pathname: "/create-request",
              state: { segment_id: segment },
            });
          } else {
            this.props.history.push({
              pathname: "/view-request",
              state: { status: response.data.StatusCode },
            });
          }
        } else if (
          response.data.StatusCode === "402" &&
          eventType !== "create-request"
        ) {
          sessionStorage.setItem("AccountNumber", this.state.accountNumber);
          sessionStorage.setItem(
            "Address",
            this.state.houseNumber +
              " " +
              this.state.streetName +
              " " +
              this.state.city +
              " " +
              this.state.province
          );
          let userAddress = {
            houseNumber: this.state.houseNumber,
            streetName: this.state.streetName,
            city: this.state.city,
            province: this.state.province,
            streetAddress: this.streetAddress,
          };
          sessionStorage.setItem("ud", JSON.stringify(userAddress));
          this.props.history.push({
            pathname: "/view-request",
            state: { status: response.data.StatusCode },
          });
        } else {
          this.setState({ valid: false });
          this.setState({ errorHeader: "Error" });
          this.setState({ errorMessage: "\n" + response.data.Message });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.setState({ valid: false });
        this.setState({ errorHeader: "Error" });
        this.setState({
          errorMessage: "\nSomething went wrong. Please try again.",
        });
      });
  };

  getAlertAPI() {
    //this.setState({loading: true});

    SampleAlert.every((item) => {
      if (item.Name === process.env.REACT_APP_SERVICE_PROVIDER_NAME) {
        this.setState({ alertHeader: item.Header__c });
        this.setState({ alertMessage: item.Body__c });
        return false;
      }
      return true;
    });
  }

  constructor(props) {
    super(props);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onTagsChange = this.onTagsChange.bind(this);
    // this.selectedValues = this.selectedValues.bind(this);
  }

  onKeyPress(event) {
    // if(event.keyCode === 27) {
    const billImageElement = document.getElementById("billImage");
    billImageElement.style.transform = "";
    billImageElement.style.transition = "";
    // }
  }

  enlargeImg = (event) => {
    if (!event.target.style.transform)
      event.target.style.transform = "scale(2.5)";
    else event.target.style.transform = "";

    // Animation effect
    if (!event.target.style.transition)
      event.target.style.transition = "transform 0.25s ease";
    else event.target.style.transition = "";
  };

  onBillingAccountNumberChecked = (event) => {
    this.setState({ checkNoBillingNumber: event.target.checked });
    var message = this.state.errorMessage;
    if (event.target.checked) {
      this.setState({ accountNumber: "" });
      document.querySelector('input[id = "accountNumber"]').value = "";
      message = message.replace("\n Account Number", "");
      if (message.trim().length === 0) {
        this.setState({ valid: true });
      }
    } else {
      if (
        this.state.errorHeader.length !== 0 &&
        this.state.errorHeader === "Required Field"
      ) {
        if (
          this.state.accountNumber.length === 0 &&
          !message.includes("Account Number")
        ) {
          message = "\n Account Number" + message;
          this.setState({ valid: false });
        }
      }
    }
    this.setState({ errorMessage: message });
  };

  onSearchButtonClicked = (event) => {
    const isValid = this.checkValidity();
    if (isValid) {
      this.authenticateUserAPI("create-request");
    }
  };

  onViewServiceRequestClicked = () => {
    const isValid = this.checkValidity();
    if (isValid) {
      this.authenticateUserAPI("view-request");
    }
  };

  // onStreetTypeSelected = (event) => {
  //   this.setState({ streetType: event.target.value.trim() });
  // };

  onSetProvinceValues = (data) => {
    this.setState({ setProvinceValues: data });
  };

  onTagsChange = (value) => {
    this.setState({
      houseNumber: value ? value.HouseNumber : "",
      streetName: value ? value.StreetName : "",
      city: value ? value.City : "",
      province: value ? value.Province : "",
      unitNumber: value ? value.UnitNumber : "",
      value: value
        ? `${value.HouseNumber} ${value.StreetName}  ${
            value.UnitNumber ? value.UnitNumber : ""
          }`
        : "",
    });
  };

  render() {
    if (this.state.setProvinceValues.length <= 0) {
      axiosStreet
        .get("./province.json")
        .then((res) => {
          this.onSetProvinceValues(res.data);
        })
        .catch((err) => {});
    }

    const styleShowHide = {
      display: "none",
    };

    const styleShowHideWarningMessage = {
      display: "none",
    };

    var disableField = {
      disabled: true,
    };

    if (this.state.checkNoBillingNumber) {
      styleShowHide.display = "none";
      styleShowHideWarningMessage.display = "flex";
      disableField.disabled = true;
    } else {
      styleShowHide.display = "inline";
      styleShowHideWarningMessage.display = "none";
      disableField.disabled = false;
    }

    var showErrorMessage = "";
    var loadingScreen = "";

    var showAsList = {
      // whiteSpace: 'pre-wrap'
    };

    if (!this.state.valid) {
      showErrorMessage = (
        <div>
          <br />
          <Alert variant="danger">
            <p style={showAsList}>
              <b>{this.state.errorHeader}</b>
              <div
                dangerouslySetInnerHTML={{ __html: this.state.errorMessage }}
              />
            </p>
            {/*new code - RDI-4285*/}
            {/* <p>
              <b>Tip:</b> Remember to include your street's quadrant (e.g. NW,
              SW) in the <b>'Province'</b> field.
            </p> */}
          </Alert>
        </div>
      );
    }

    if (this.state.loading) {
      loadingScreen = <Loading />;
    }

    return (
      // <UserContext.Consumer>
      //   {(context) => (

      <Container className="wrapper">
        <br />
        {this.state.alertMessage !== null && this.state.alertMessage !== "" ? (
          <Alert variant="primary">
            <Alert.Heading>{this.state.alertHeader}</Alert.Heading>
            <p className="alert-margin-bottom">{this.state.alertMessage}</p>
          </Alert>
        ) : null}
        <br />
        {/* new code - RDI-4285 */}
        {/* <h1 className="header">Submit a Cart Maintenance or Exchange Request</h1> */}
        <h1 className="header">Submit a cart repair or exchange request</h1>

        <p className="hide">
          <br />
          Welcome to the City of Edmonton's cart maintenance request service.
          This service allows you to submit requests for maintenance of your
          garbage cart.
        </p>
        <p className="hide">
          TO BEGIN - search for your account by completing the required fields
          below
        </p>
        <br />
        <br />
        <Form>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid xs={12}>
              <Col>
                <h5>Enter your address</h5>
              </Col>
              <br />
            </Grid>
            <Grid xs={4} controlId="formhouseNumber">
              <Col>
                <AddressInput
                  onChangeEvent={this.onTagsChange}
                  value={this.state.value}
                />
              </Col>
            </Grid>
            <Grid xs={4} controlId="formCity">
              <Col>
                <TextField
                  fullWidth
                  required
                  label="City"
                  value={this.state.city}
                  onChange={(event) =>
                    this.setState({ city: event.target.value.trim() })
                  }
                  error={!this.state.valid && this.state.city.length === 0}
                />
              </Col>
            </Grid>
            <Grid xs={4} controlId="formProvince">
              <Col>
                <FormControl
                  fullWidth
                  error={!this.state.valid && this.state.province.length === 0}
                  required
                >
                  <InputLabel>Province</InputLabel>
                  <Select
                    value={this.state.province}
                    onChange={(event) =>
                      this.setState({ province: event.target.value.trim() })
                    }
                    label="Province"
                    MenuProps={{ disablePortal: true }}
                  >
                    {this.state.setProvinceValues.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* <FormHelperText>Province</FormHelperText> */}
                </FormControl>
              </Col>
            </Grid>

            <Grid xs={12} style={{ marginTop: 20 }}>
              <Col>
                <p className="horizontal-line" />
              </Col>
            </Grid>

            <Grid xs={12} style={{ marginTop: 10 }}>
              <Col>
                <h5>EPCOR account number</h5>
                <br />
              </Col>
            </Grid>

            <Grid xs={6}>
              <Col>
                <TextField
                  id="accountNumber"
                  required
                  fullWidth
                  label="Account number"
                  value={this.state.accountNumber}
                  onChange={(event) =>
                    this.setState({ accountNumber: event.target.value.trim() })
                  }
                  error={
                    !this.state.valid &&
                    !this.state.checkNoBillingNumber &&
                    this.state.accountNumber.length === 0
                  }
                  disabled={disableField.disabled}
                  helperText="Your EPCOR account number can be found on your bill."
                />
                <Form.Check
                  id="checkBillingAccount"
                  type="checkbox"
                  label="I do not have an EPCOR account number"
                  checked={this.state.checkNoBillingNumber}
                  onChange={(event) =>
                    this.onBillingAccountNumberChecked(event)
                  }
                />
              </Col>
            </Grid>
            <Grid xs={6}>
              <Col>
                <Image
                  style={{ cursor: "pointer", zIndex: 9 }}
                  src="./bill.png"
                  alt="bill Image"
                  height="20%"
                  width="50%"
                  onClick={this.enlargeImg}
                  id="billImage"
                />
                <br />
              </Col>
            </Grid>

            <Grid xs={12} style={styleShowHideWarningMessage}>
              <Col>
                <p>
                  <b>Please note:</b> You will not be able to request a cart size exchange without an EPCOR account number.
                </p>
              </Col>
            </Grid>
          </Grid>

          <Form.Group
            as={Row}
            controlId="errorMessage"
            className="d-flex justify-content-between flex-wrap align-items-center"
          >
            <Col className="right-padding-zero">{showErrorMessage}</Col>
          </Form.Group>

          <Form.Group
            as={Row}
            className="d-flex justify-content-between flex-wrap no-wrap align-items-center no-padding"
          >
            <Col>
              <Button
                variant="success"
                onClick={(event) => this.onSearchButtonClicked(event)}
                block
                className="green-button"
              >
                Search
              </Button>
            </Col>
            <Col>
              <Button
                variant="custom"
                onClick={(event) => this.onViewServiceRequestClicked(event)}
                block
                className="light-grey-button"
              >
                View Scheduled/Completed Requests
              </Button>
            </Col>
            <Col>
              <Button
                variant="custom"
                type="submit"
                block
                className="light-grey-button"
              >
                Clear
              </Button>
            </Col>
          </Form.Group>
        </Form>
        {loadingScreen}
      </Container>
    );
  }
}

export default UserDetails;